package nl.appstuff.padelchecker.pages.padel

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import nl.appstuff.padelchecker.site.PageSeo
import nl.appstuff.padelchecker.site.StructuredData
import nl.appstuff.padelchecker.site.components.NavBar
import nl.appstuff.padelchecker.site.components.sections.FooterSection
import nl.appstuff.padelchecker.site.directory.Directory
import nl.appstuff.padelchecker.site.directory.DirectoryClub
import nl.appstuff.padelchecker.site.directory.DirectoryContentBox
import nl.appstuff.padelchecker.site.directory.DirectoryGrid
import nl.appstuff.padelchecker.site.directory.DirectoryHeading
import nl.appstuff.padelchecker.site.directory.DirectoryLink
import nl.appstuff.padelchecker.site.directory.DirectoryParagraph
import nl.appstuff.padelchecker.site.directory.DirectorySubheading
import nl.appstuff.padelchecker.site.localization.LocalSiteStrings
import nl.appstuff.padelchecker.site.localization.SiteStrings
import org.jetbrains.compose.web.css.vh

@Page("/padel/{city}")
@Composable
fun CityPage() {
    val strings = LocalSiteStrings.current
    val citySlug = rememberPageContext().route.params["city"].orEmpty()
    val city = Directory.city(citySlug)
    val clubs = Directory.clubsInCity(citySlug)

    if (city == null) {
        PageSeo(
            title = "${strings.directoryCityNotFoundTitle} – Padelchecker",
            description = strings.directoryCityNotFoundBody,
            canonicalPath = "/padel",
        )
    } else {
        PageSeo(
            title = strings.directoryCitySeoTitle(city.name, clubs.size),
            description = strings.directoryCitySeoDescription(clubs.size, city.name, city.provinceName),
            canonicalPath = "/padel/${city.slug}",
        )
        CityStructuredData(city.name, clubs, strings)
    }

    Column(modifier = Modifier.fillMaxWidth().minHeight(100.vh)) {
        NavBar()
        DirectoryContentBox {
            if (city == null) {
                DirectoryHeading(strings.directoryCityNotFoundTitle)
                DirectoryParagraph(strings.directoryCityNotFoundBody)
                DirectoryLink("/padel", strings.directoryCitySeeAll)
            } else {
                DirectoryHeading(strings.directoryCityHeading(city.name))
                DirectoryParagraph(
                    strings.directoryCityIntro(city.name, city.provinceName, clubs.size, clubs.size == 1)
                )

                DirectorySubheading(strings.directoryCityClubsHeading(city.name))
                DirectoryGrid {
                    clubs.sortedBy { it.name }.forEach { club ->
                        DirectoryLink(
                            href = "/padel/${club.citySlug}/${club.slug}",
                            label = club.name,
                        )
                    }
                }

                DirectoryLink("/padel-in/${city.provinceSlug}", strings.directoryCityBackToProvince(city.provinceName))
            }
        }
        FooterSection()
    }
}

@Composable
private fun CityStructuredData(cityName: String, clubs: List<DirectoryClub>, strings: SiteStrings) {
    val items = clubs.mapIndexed { i, club ->
        """
        {
          "@type": "ListItem",
          "position": ${i + 1},
          "url": "https://padelchecker.nl/site/padel/${club.citySlug}/${club.slug}",
          "name": ${jsonString(club.name)}
        }
        """.trimIndent()
    }.joinToString(",\n")
    StructuredData(
        """
        {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": ${jsonString(strings.directoryStructuredDataClubsIn(cityName))},
          "itemListElement": [
        $items
          ]
        }
        """.trimIndent()
    )
}
